import { lazy } from "react";
// Jumper
import { ErrorPage } from "../components/ErrorPage";
import { SharePraser } from "../components/SharePraser";
import { Sketchfab } from "../components/Sketchfab";
// Handler
import OAuthHandler from "../common/Provider/oauth";
import PaymentHandler from "../common/Provider/payment";
import { microAppsConfig } from "../utils/qiankun/microAppsConfig";
// Main components
const ChatAvatar = lazy(() => import("../components/ChatAvatar"));
const Rodin = lazy(() => import("../components/Rodin"));
import NewRodin from "../components/newRodin";
// Mobile components
const Snap = lazy(() => import("../mobilecomponents/Snap"));
const Login = lazy(() => import("../mobilecomponents/login"));

const PCRouter = [
  // NOTE: To any future changes to element ChatAvatar,
  // Please note it is also used as a fillin for the following routes:
  // - /subscribe
  // - /legal/terms
  // - /legal/privacy
  // so if you change the element, please make sure to update the above routes as well.
  // - eric
  {
    path: "/auth/sketchfab",
    element: <Sketchfab />,
  },
  {
    path: "/",
    element: <NewRodin />,
  },
  {
    path: "/chatavatar/:taskUUid?",
    element: <ChatAvatar />,
  },
  {
    path: "/result/detail/:taskUUid",
    element: <SharePraser />,
  },
  {
    path: "/imageto3d/:taskUUid?",
    element: <ChatAvatar />,
  },
  {
    path: "/rodin",
    element: <NewRodin />,
  },
  {
    path: "/:lang/rodin",
    element: <NewRodin />,
  },
  {
    path: "/rodin/page/:page?",
    element: <NewRodin />,
  },
  {
    path: "/rodin/tab/:tab?",
    element: <NewRodin />,
  },
  {
    path: "/rodin/search/:keyword?",
    element: <NewRodin />,
  },
  {
    path: "/rodin/:taskUUid?",
    element: <NewRodin />,
  },
  {
    path: "/snap",
    element: <Snap />,
  },
  {
    path: "/error",
    element: <ErrorPage />,
  },
  {
    path: "/payment",
    element: <PaymentHandler />,
  },
  {
    path: "/login",
    element: <OAuthHandler />,
  },
  {
    path: "/customlogin",
    element: <Login />,
  },
  {
    path: "/user/login",
    element: <NewRodin />,
  },
  {
    path: "/signup",
    element: <NewRodin />,
  },
  {
    path: "/subscribe",
    element: <NewRodin />,
  },
  {
    path: "/referral",
    element: <NewRodin />,
  },
  {
    path: "/api-dashboard",
    element: <NewRodin />,
  },
  {
    path: "/legal/terms",
    element: <NewRodin />,
  },
  {
    path: "/legal/privacy",
    element: <NewRodin />,
  },
  {
    path: "/legal/fulfillment",
    element: <NewRodin />,
  },
  {
    path: "/product/*",
    element: <ChatAvatar />,
  },
  ...microAppsConfig.map((config) => ({
    path: config.activeRule + "/*",
    element: null,
  })),
  {
    path: "/MeshEditor", // For NetEase Only
    element: null,
  },
  {
    path: "/rodin/*",
    element: <ErrorPage errorCode={404} isFullPage={true} />,
  },
];

export default PCRouter;
